import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
// Components
import { Input, Text } from 'src/Components'
// Styles
import styles from './RoomCount.module.scss'
import filterStyles from '../Filters.module.scss'

const RoomCount = ({ heading, name, value }) => (
  <>
    <Text
      align='left'
      element='h2'
      weight='bold'
      variant='neutralCool'
      variantCount='900'
      className={filterStyles.sectionTitle}
    >
      {heading}
    </Text>
    <div className={styles.radioFields}>
      <div className={styles.radio}>
        <Input
          type='radio'
          name={name}
          data-qa={name}
          defaultChecked={!value}
          id={`${name}Any`}
          value={null}
        />
        <label htmlFor={`${name}Any`}>
          <FormattedMessage
            id='HomeSearch.listings.filters.radio.any'
            defaultMessage='Any'
          />
        </label>
      </div>
      <div className={styles.radio}>
        <Input
          type='radio'
          name={name}
          data-qa={name}
          defaultChecked={value === 1}
          id={`${name}1`}
          value='1'
        />
        <label htmlFor={`${name}1`}>
          <FormattedMessage
            id='HomeSearch.listings.filters.radio.1'
            defaultMessage='1+'
          />
        </label>
      </div>
      <div className={styles.radio}>
        <Input
          type='radio'
          name={name}
          data-qa={name}
          defaultChecked={value === 2}
          id={`${name}2`}
          value='2'
        />
        <label htmlFor={`${name}2`}>
          <FormattedMessage
            id='HomeSearch.listings.filters.radio.2'
            defaultMessage='2+'
          />
        </label>
      </div>
      <div className={styles.radio}>
        <Input
          type='radio'
          name={name}
          data-qa={name}
          defaultChecked={value === 3}
          id={`${name}3`}
          value='3'
        />
        <label htmlFor={`${name}3`}>
          <FormattedMessage
            id='HomeSearch.listings.filters.radio.3'
            defaultMessage='3+'
          />
        </label>
      </div>
      <div className={styles.radio}>
        <Input
          type='radio'
          name={name}
          data-qa={name}
          defaultChecked={value === 4}
          id={`${name}4`}
          value='4'
        />
        <label htmlFor={`${name}4`}>
          <FormattedMessage
            id='HomeSearch.listings.filters.radio.4'
            defaultMessage='4+'
          />
        </label>
      </div>
      <div className={styles.radio}>
        <Input
          type='radio'
          name={name}
          data-qa={name}
          defaultChecked={value === 5}
          id={`${name}5`}
          value='5'
        />
        <label htmlFor={`${name}5`}>
          <FormattedMessage
            id='HomeSearch.listings.filters.radio.5'
            defaultMessage='5+'
          />
        </label>
      </div>
    </div>
  </>
)

RoomCount.propTypes = {
  heading: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.number,
}

export default RoomCount
